module.exports = __webpack_public_path__ + "img/nf.39595efe.png";